import React from "react";
import { CourseItem } from "service/service";
import { atom } from "jotai";
import { SourceItem } from "../ResourcePool/service";

interface CourseContextProps {
    course: CourseItem;
    basename: string;
    path: string;
}

export const CourseContext = React.createContext<CourseContextProps>({
    course: {} as CourseItem,
    basename: "",
    path: ""
});

export const resourceModalAtom = atom<string | null>(null);

// 课件状态 ----------------------------------------------- //

// 当前播放的课件信息
export const currentResourceAtom = atom<SourceItem | null>(null);

// 签到状态 ----------------------------------------------- //

// 当前签到信息
export const currentSignInAtom = atom<number | null>(null);

// 选人状态 ----------------------------------------------- //

// 投票状态 ----------------------------------------------- //
